import { render, staticRenderFns } from "./FormThuxHorizontalTextArea.vue?vue&type=template&id=20dfa9a8&"
import script from "./FormThuxHorizontalTextArea.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports